import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import css from "./style.less";
import { useI18n } from "../../i18n/useI18n";
import img from "../../assets/empty-state-negative.svg";
import { routeURLs } from "../../utils/enums";
import { getCookie } from "../../serviceWorker";
import { removeLocalStorageFlag, setLocalStorageFlag, updateCookie } from "../../utils/common";
import { setFeatures } from "../../generics/AppHOC/actions";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
const [HbrLink] = reactWrapper(["hbr-link"]);
const OverlayNotProvisioned = () => {
  const { tCommon } = useI18n('common');
  const navigate = useNavigate(); 
  const isUIconvergence = getCookie("cl-analytics");

  const handleSelectOverlay = useCallback(() => { 
    // Clear overlay-related localStorage
    removeLocalStorageFlag("currentOverlay");
    removeLocalStorageFlag("currentOverlayName");
    removeLocalStorageFlag("roles");
    setLocalStorageFlag("currentPath", "overview");
    updateCookie("currentPath", "overview");

    // Reset features state to clear the error
    setFeatures({
      fabric: null,
      loader: true,
      error: null,
      available: [],
      enabled: []
    });
    // Navigate to accounts
    navigate(routeURLs.accounts);
  }, [navigate]); 
  return (
    <div className={css["overlay-not-provisioned"]} data-cy="overlay-not-provisioned">
      <div className="error-image">
        <img
          src={img}
          alt={tCommon('overlayNotProvisionedAlt')}
        />
      </div>
      <div className="message-content">
        <h2>{tCommon('overlayNotProvisionedTitle')}</h2>
        <p>{tCommon('overlayNotProvisionedMessage')}</p>
        {!isUIconvergence && (
          <HbrLink onClick={handleSelectOverlay}>
            {tCommon('overlayNotProvisionedLink')}
          </HbrLink>
        )}
      </div>
    </div>
  );
};

export default OverlayNotProvisioned;
